<template>
  <div class="py-4 px-4 mt-5">
    <div class="row">
      <div class="col-4">
        <h4>{{ $t("message.education.choose_category") }}</h4>
        <div>
          <button
            class="btn"
            :class="video == 'ca' ? 'btn-primary' : 'btn-link'"
            @click="setVideo('ca')"
          >
            {{ $t("message.menu.comply_advantage") }}
          </button>
        </div>
        <div>
          <button
            class="btn"
            :class="video == '410' ? 'btn-primary' : 'btn-link'"
            @click="setVideo('410')"
          >
            {{ $t("message.menu.find_partner_410") }}
          </button>
        </div>
        <div>
          <button
            class="btn"
            :class="video == '886' ? 'btn-primary' : 'btn-link'"
            @click="setVideo('886')"
          >
            {{ $t("message.menu.find_partner") }}
          </button>
        </div>
        <div>
          <button
            class="btn"
            :class="video == 'note' ? 'btn-primary' : 'btn-link'"
            @click="setVideo('note')"
          >
            {{ $t("message.menu.business_note") }}
          </button>
        </div>
      </div>
      <div class="col-8">
        <video
          style="width: 100%"
          v-if="video !== ''"
          :src="videos[video]"
          controls
        ></video>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EducationVideos",
  mounted() {
    setTimeout(() => {
      if (this.$route.params.hash && this.$route.params.hash !== "") {
        this.setVideo(this.$route.params.hash);
      }
    }, 400);
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.setVideo(this.$route.params.hash);
      },
    },
  },
  data() {
    return {
      video: "",
      videos: {
        ca: "ca.mp4",
        410: "410.mp4",
        886: "886.mp4",
        note: "note.mp4",
      },
    };
  },
  methods: {
    setVideo(param) {
      this.video = param;
    },
  },
};
</script>
<style scoped>
video {
  width: 100%;
}
</style>
